@if (!collection.publication) {
   <h3 class="mt-1 mb-3"> {{ 'collection.share.publication.explanation'|translate }}</h3>
} @else {
    <h3 class="mt-1 mb-3">{{ 'collection.share.publication.revoke'|translate }}</h3>
}

@if (error) {
    <div class="error">
        {{ 'collection.share.publication.error'|translate }}
    </div>
}


    <form [formGroup]="publicationForm!">
        <mat-form-field>
            <mat-label>{{ 'collection.share.link.permission'| translate }}</mat-label>
            <mat-select formControlName="permission">
                <mat-option value="download">{{ 'collection.access.download'|translate }}</mat-option>
                <mat-option value="view">{{ 'collection.access.view'|translate }}</mat-option>
            </mat-select>
        </mat-form-field>
    </form>

<footer>
    <div class="btn-row">
       <div> <button mat-button (click)="back.emit()">{{ 'button.cancel'|translate }}</button></div>
        <div>
            @if (collection.publication) {
                <button mat-raised-button (click)="revokePublication()"> {{ 'collection.action.revokepublic'|translate }}</button>
                <button mat-raised-button class="me-2" (click)="updatePermission()"> {{ 'collection.action.updateLink'|translate }}</button>
            } @else {
                <button mat-raised-button (click)="makePublic()"> {{ 'collection.action.share'|translate }}</button>
            }
        </div>
    </div>

</footer>
